module.exports = __webpack_public_path__ + "static/media/magnifying_glass.70c2b0c4.svg";